import { parsePhoneNumberFromString } from 'libphonenumber-js/mobile'

export const formatMobilePhone = (phoneNumber) => {
    const sanitizedNumber = parsePhoneNumberFromString(phoneNumber, "FR")
    if (!sanitizedNumber || !sanitizedNumber.number || !sanitizedNumber.number.length) return ''

    // check if mobile
    if (!['6','7'].includes(sanitizedNumber.nationalNumber.substr(0,1))) return ''

    return `${sanitizedNumber.countryCallingCode}${sanitizedNumber.nationalNumber}`
}



// WEBPACK FOOTER //
// ./src/logic/utils/phoneNumber.js